import { render, staticRenderFns } from "./RolesPopup.vue?vue&type=template&id=cf4723c4"
import script from "./RolesPopup.vue?vue&type=script&lang=ts"
export * from "./RolesPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports